import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ScalableCapitalIcon from "@icons/myicons/banks/scalable.svg?react";
import ParqetIcon from "@icons/myicons/banks/parqet.svg?react";
import ExtraETFIcon from "@icons/myicons/banks/extra-etf.svg?react";
import FinanzguruIcon from "@icons/myicons/banks/finanzguru.svg?react";
import N26Icon from "@icons/myicons/banks/n26.svg?react";
import OutbankIcon from "@icons/myicons/banks/outbank.svg?react";
import PortfolioPerformanceDepotIcon from "@icons/myicons/banks/portfolio-performance.svg?react";

export const useSupportedCSVImportBanks = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        depot: {
          name: "extraETF",
          icon: <ExtraETFIcon />,
        },
        account: {
          name: "Finanzguru (.xlsx)",
          icon: <FinanzguruIcon />,
        },
      },
      {
        depot: {
          name: "Parqet",
          icon: <ParqetIcon />,
        },
        account: {
          name: "N26",
          icon: <N26Icon />,
        },
      },
      {
        depot: {
          name: "Scalable Capital",
          icon: <ScalableCapitalIcon />,
        },
        account: {
          name: "Outbank",
          icon: <OutbankIcon />,
        },
      },
      {
        depot: {
          name: t("csvImport.banksTable.portfolioPerformanceDepot"),
          icon: <PortfolioPerformanceDepotIcon />,
        },
        account: {
          name: t("csvImport.banksTable.portfolioPerformanceAccount"),
          icon: <PortfolioPerformanceDepotIcon />,
        },
      },
    ],
    [t]
  );
};
